import $ from 'jquery';

const $list = $('.radio-list');

$(function () {
    if ($list.length > 0) {
        $list.each(function () {
            radioList($(this));
        });
    }
});

const radioList = (listEl) => {
    listEl.find('.radio').on('click', function () {
        listEl.find('.radio__control').filter(':checked').prop('checked', false);
        $(this).find('.radio__control').prop('checked', true).trigger('radiolist:changed');
    });
};
